/*
 * @Version    : v1.00
 * @Author     : wuyujiang
 * @Date       : 2025-10-27 10:15
 * @LastAuthor : wuyujiang
 * @LastTime   : 2025-11-21 14:19
 * @desc       :
 */
// en.js
export default {
  centerAgent: {
    subagency: "Sub-agency",
    search: "Search",
    subagencyIncome: "Sub-agency Income",
    last29Days: "Last 29 Days",
    excludingToday: "Excluding today",
    commission: "Commission",
    last30Days: "Last 30 Days Data",
    rank: "Rank",
    hostNumber: "Host Number",
    recent30Days: "Recent 30 Days Host Income",
    commissionRate: "Commission Rate",
    myCommission: "My Commission",
    remove: "Remove",
    thisAction:
      "This action will remove the {hostoragent} {hostname}  from your team. Do you confirm to proceed",
    dashboard: "Dashboard",
    information: "Information",
    dataCenter: "Data Center",
    hostList: "Host List",
    bdList: "BD List",
    agencyList: "Agency List",
    myRight: "My Right",
    numberOf: "Number of Agency",
    inviteAgency: "Invite Agency",
    numberOfHost: "Number of Host",
    inviteHost: "Invite Host",
    inviteHostlinkcopied: "Invitation link copied",
    tipsShare: "Tips : Share the invitation link with your friends.",
    thisMonthD: "This Month Data",
    formDay1: "form {day1} to {day2}",
    hostGift: "Host Gift Point",
    agentCommission: "Agent Commission",
    currentLevel: "Current Level",
    commissionRateOf: "Commission rate of agents income",
    baseSalary: "Base salary",
    stillNeed: "Still need",
    toReach: "to reach next level",
    reachedthe: "The highest level has been reached.",
    advertisementTask: "Advertisement Task",
    dataOverview: "Data Overview",
    today: "Today",
    hostPoint: "Host Point",
    agentsPoints: "Agents Points Income",
    thisMonth: "This Month",
    month: "Month",
    lastMonth: "Last Month",
    bdNumber: "BD Number",
    hostIncome: "Host Income",
    todayIncome: "Today Income",
    past30Days: "Past 30 Days",
    host: "Host",
    country: "Country",
    level7: "Level / 7-Day Revenue",
    pointIncome: "Point Income",
    liveDuration: "Live Duration",
    joinTime: "Join time",
    state: "State",
    operation: "operation",
    bd: "BD",
    totalHosts: "Total Hosts Income",
    totalAgents: "Total Agents Income",
    agent: "Agent",
    agentLevel: "Agent Level / Commission Rate",
    commissionIncome: "Commission Income",
    showDirect: "Show direct agents only.Excluding today's data",
    excludingTodayData: "Excluding today's data",
    packages: "Packages",
    contents: "Contents",
    balance: "Balance",
    release: "Release",
    issue: "Issue",
    createBd: "Create BD",
    times: "times",
    authorizeCs: "Authorize CS",
    giftTo: "Gift to User",
    bdCreation: "BD creation limit remaining",
    csAuthorization: "CS authorization quota remaining",
    giftName: "Gift Name",
    giftContents: "Gift Contents",
    check: "Check",
    cancel: "Cancel",
    tip: "Tip",
    recipientsVip:
      "Recipient's VIP tier exceeds gift package limit. VIP benefits from this gift will be disabled.Sure to continue?",
    confirm: "Confirm",
    authorize: "Authorize",
    inviteBy: "Invite by User ID",
    invite: "Invite",
    inviteLink: "Invite link",
    copy: "Copy",
    success: "success",
    pleaseCheck: "Please Check User Id",
    totalGift:
      "Total Gift Income of All Hosts (excluding platform rewards like rankings, tasks, etc.), including the gift income of sub agencies.",
    totalAgentsCom:
      "Total agents' commission from their host income, including the sub agents' commission.",
    allAgent: "All Agent",
    directAgent: "DIRECT AGENT",
    indirectAgent: "INDIRECT AGENT",
    newUpgraded: "New Upgraded Agent",
    newS: "New S Agents",
    newB: "New B Agents",
    newC: "New C Agents",
    expectedReward: "Expected Reward",
    newA: "New A Agents",
    agencyLevel: "Agency Level",
    nickname: "Nickname",
    upgradeDate: "Upgrade Date",
    bdPolicy: "BD Policy",
    agencyDetail: "Agency Detail",
    agency: "Agency",
    hostCommission: "host commission",
    last6Days: "Last 6 Days",
    giftIncome: "Gift Income",
    mins: "** mins",
    agencyCenter: "Agency Center",
    myIncome: " My Income Today:",
    totalHost: "Total Host Points:",
    overview: "Overview",
    hostPoints: "Host Points",
    myHosts: "My Hosts Points",
    subagentHost: "Sub-agent Host Points",
    subagencyNumber: "Sub-agency Number",
    otherIncome: "Other income",
    contactAdmin: "Contact Admin",
    whatsapp: "WhatsAPP",
    bdCenter: "BD Center",
    copySuccess: "copy success",
    pleaseInput: "Please Input the User ID",
    agencyPolicy: "Agency Policy",
    agencyCommission: "Agency Commission",
    agencyCommission2:
      "Agency Commission = Commission Rate × Total Gift Income of All Hosts",
    excludingPlatform:
      "   (excluding platform rewards like rankings, tasks, etc.)",
    agencyCommissionCalculation: "Agency Commission Calculation",
    level: "Level",
    pointsTarget: "Points Target(Last 30 Days)",
    points10000: "10,000 Points =1 USD (M= million)",
    note1:
      "Note 1: Total Valid Income = Your agency income + Each tier of your sub-agencies income",
    note2:
      "Note 2: Agency commissions will be credited in real-time when the host receives a gift.",
    note3:
      "Note 3: The minimum withdrawal amount is 10 USD, and withdrawals must be made in multiples of 10 (e.g., 10 USD, 20 USD, 30 USD).",
    subagencycommission: "Sub-AgencyCommission",
    theMain:
      " The main agency can earn commissions from the income of each tier of sub-agencies (T1, T2, T3, T4, ... Tn), with a maximum commission rate of 16%.",
    forExample: "For example:",
    agencyA: "  Agency A invites Agency B and Agency C.",
    agencyB: "   Agency B invites Agency D and Agency E.",
    agencyC: "   Agency C invites Agency F.",
    noteFigures:
      "   (Note: figures in parentheses represent the income of hosts under each agency).",
    thusWe:
      "Thus, we can calculate the Total Valid Income and Commission Rate of agencies from Agency A to Agency F.",
    totalValid:
      " Total Valid Income = Your Agency’s Income + The Income from Each Tier of Sub - Agencies",
    aTotal:
      "A Total Valid Income = A + B + C + D + E + F = 10M + 20M + 70M + 20M + 30M +80M = 230M (20% commission rate)",
    bTotal:
      "B Total Valid Income = B + D + E = 20M + 20M + 30M = 70M (16% commission rate)",
    cTotal:
      "C Total Valid Income = C + F = 70M + 80M =150M (20% commission rate)",
    dTotal: "D Total Valid Income =20M (12% commission rate)",
    eTotal: "E Total Valid Income =30M (12% commission rate)",
    fTotal: "F Total Valid Income =80M (16% commission rate)",
    subagencyCommission:
      " Sub-agency Commission = (Main agency commission rate - Sub-agency commission rate) × Total Valid Income of the sub-agency",
    agencyAC: "Agency {A}'s commission from Agency {B}",
    thereforeAgency:
      "Therefore, Agency {A}'s total commission from sub-agencies",
    sinceAgency:
      "Since Agency D, E, and F have no sub-agency, they cannot earn sub-agency commissions",
    seniorPolicy: "Senior policy",
    nomore: "No more data",
    active: "Active",
    disabled: "Disabled",
    deleted: "Deleted",
    lastLogintime: "Last Logintime",
    onmic: "On Mic Today",
    editNickname: "Edit Nickname",
    editNicknameTip: "You can change your agency name once per month for free",
    enterNewNickname: "Enter new nickname",
    nicknameUpdateSuccess: "Nickname updated successfully",
    cannotEditNickname: "Cannot Edit Nickname",
    cannotEditTip:
      "You can only edit your nickname once for free. Please contact customer support to modify your nickname.",
    alreadyChangedTip:
      "You have already changed your agency name this month. Additional changes cost 8,000 coins.",
    payAndSave: "Pay and save",
  },
  sellerCoin: {
    detailsOf: "Details of Withdrawal",
    fundsSent: "Funds Sent",
    transfer: "Transfer",
    totalIncome: "Total Income",
    orderIncome: "Order Income",
    estimatedReward: "Estimated Reward",
    amount: "Amount",
    applicantId: "Applicant ID",
    applicantName: "Applicant Name",
    orderId: "Order ID",
    uploadScreenshot: "Upload Screenshot",
    ensureWithdrawal:
      "Ensure withdrawal is successful, then upload screenshot and click the button below to notify the applicant.",
    remain: "Remain",
    pleasePay:
      " Please pay immediately and upload the receipt. If you exceed the time limit, the payment qualification of the order will be cancelled.",
    youCan:
      "You can upload 3 picture at most. Verify that the account name matches applicant's.",
    pleaseComplete: "Please complete the withdrawal in time ",
    unableTo: " Unable to pay, Refuse",
    notifyThe: " Notify the applicant",
    youCanGet:
      "You can get 1%-3% extra bonus if you deal with the orders timely.",
    ifYou:
      "If you deal with the orders within {min} mins you can get {persent}% bonus.",
    egThe:
      "e.g.: The order worth 90000 points, you deal with it within 30 mins, you can get 3% bonus, which is 90000 × 3% = 2700 points.",
    gotIt: "Got it",
    pleaseUpload: "Please upload image",
    detail: "Detail",
    balance: "Balance",
    exchange: "Exchange",
    all: "All",
    recharge: "Recharge",
    official: "Official",
    exchangeDetail: "Exchange Detail",
    coinSeller: "Coin Seller",
    levelUp: "Level Up",
    currentLevel: "Current level",
    myBalance: "My Balance",
    details: "Details",
    paymentMethod: "Payment Method",
    myOrder: "My Order",
    paymentMenthod: "Payment Menthod",
    acceptingOrders: "Accepting Orders",
    unavailable: "Unavailable",
    greetingMessage: "Greeting Message Settings",
    serviceUnavailable: "Service Unavailable",
    thisFeature:
      "This feature is temporarily locked. Please contact customer support for assistance.",
    editMessage: "Edit Message",
    customizeYour:
      "Customize your greeting message. You can include helpful information about recharging coins. ",
    theMessage:
      "The Message will be automatically sent when a new user starts a private chat with you",
    save: "Save",
    pleaseEnterMessge: "Please Enter your greeting message",
    salesMethod: "Sales Method",
    user: "User",
    coinseller: "Coinseller",
    userId: "User ID",
    check: "Check",
    coinAmount: "Coin Amount",
    pleaseEnter: "Please enter a multiple of 1",
    enterAt: "Enter at least 100, in multiples of 1",
    transferDetails: "Transfer Details",
    recommendSeller: "Recommend Seller",
    recent30Day: "Recent 30-Day Coin Sales",
    whatsapp: "WhatsApp",
    chat: "Chat",
    yourCountry: "Your country currently has no available coin sellers.",
    pleaseContact: " Please contact customer support.",
    customerSupport: "customer support",
    contact: "Contact",
    customRecharge: "Custom Recharge",
    rechargeDetails: "Recharge Details",
    myPoints: "My Points",
    todayRemaining: "Today remaining quota",
    customExchange: "Custom Exchange",
    exchangeDetails: "Exchange Details",
    rechargeRules: "Recharge Rules",
    sellerLevel: "Seller Level",
    proportion: "Proportion",
    levelRequirement: "Level Requirement",
    beginner: "Beginner",
    singleRecharge: "Single recharge",
    standard: "Standard",
    senior: "Senior",
    exchangeRules: "Exchange Rules",
    note: "Note",
    seniorCoin:
      "Senior Seller can exchange up to {point} points daily at full rate. After {point}",
    beginnerSeller: "Beginner Seller",
    standardSeller: "Standard Seller",
    seniorSeller: "Senior Seller",
    claimReward: "Claim",
    claimed: "Claimed",
    incomplete: "Incomplete",
    cancel: "Cancel",
    pleaseInput: "Please input the recharge amount, minimum 10",
    pleaseInput2: "Please input the recharge amount, multiples of 100K",
    confirmation: "Confirmation",
    userName: "User Name",
    theUser: "The user has been blacklisted",
    enterAmount: "Enter amount",
    pleaseInput3: "Please input amount",
    theAmount: "The amount must be a multiple of 100000",
    pleaseInput4: "Please input or select amount",
    pleaseSelect: "Please select sales Method",
    pleaseInput5: "Please input userId",
    atLeast: "At least 100K coins to  transfer~",
    pleaseSelect2: "Please select payment Method",
    minimum: "minimum 10",
    theAmount3: "The amount must be a multiple of 1",
    lessThan: "less than or equal to 100000",
    orders: "Orders",
    applicant: "Applicant",
    method: "Method",
    withdrawTime: "Withdraw Time",
    viewDetail: "View Detail",
    toBe: "To be confirmed",
    toBePaid: "To be paid",
    toBeCompleted: "To be completed",
    completed: "Completed",
    abnormal: "Abnormal",
    refused: "Refused",
    confirmationTimeout: "Confirmation timeout",
    paymentTimeout: "Payment timeout",
    binance: "Binance",
    scanThe: "Scan the QR code to pay",
    quantity: "   Quantity",
    orderAmount: "Order amount",
    date: "Date",
    payNow: "Pay Now",
    payment: "Payment",
    pleasePay2: "Please pay in the following way",
    chainName: "Chain Name",
    contractAddress: "Contract Address",
    theAbove: "The above address is valid for this recharge only",
    copy: "Copy",
    notice: "Notice",
    pleaseTransfer:
      " Please transfer an Extra 1 USDT to cover Binance's fee.Failure to do so may delay your coin recharge.",
    paymentsMust:
      "Payments must be completed within 0.5 hour , or the platform won't be liable for any issues.",
    add: "Add",
    confirmTo: "Confirm to delete this Payment method",
    countryCurrency: "Country & Currency Type",
    selectPayment: "Select Payment method that you can remit",
    coinsSeller: "Coins Seller Rules",
    standrd: "Standrd",
    salesMethods: "Sales Methods",
    coinsellerRules: "CoinSeller Rules",
    whenApplying:
      " When applying for an upgrade to the status of a coin seller, no deposit requirements just need 1-time recharge to upgrade the coin seller level. If you choose to resign from your position as a coin seller, your current coin seller role will expire",
    youCanReplenish:
      "You can replenish your account either directly with USDT, Epay or  through another coin seller",
    fraudulentActivities:
      "Fraudulent activities are strictly prohibited within the Hala platform.",
    anyViolations:
      " Any violations will result in the termination of the coin seller's account",
    allRights: "All rights are reserved by Hala.",
    transferDetail: "Transfer Detail",
  },
  centerHost: {
    baseSalary: "Base Salary",
    invitation: "Invitation",
    tasks: "Tasks",
    other: "Other",
    consume: "Consume",
    giftIncome: "Gift Income",
    received: "Received",
    from: "from",
    luckyGift: "Lucky gift",
    hostCenter: "Host Center",
    noAgent: "No agent",
    last7: "Last 7 days",
    hourlyIncome: "Hourly income",
    toReach: "to reach",
    rules: "Rules",
    pointsOverview: "Points Overview",
    totalIncome: "Total Income",
    gifts: "Gifts",
    workDetail: "Work Detail",
    liveDuration: "Live Duration",
    mins: "mins",
    todaysLive: "Today's live record",
    dailyStatistics: " Daily Statistics",
    startTime: "Start time",
    endTime: "End time",
    duration: "Duration",
    points: "points",
    date: "Date",
    giftPoints: "Gift points",
    removeBinding: "Remove Binding",
    thisAction2:
      "This action will unbind you from {agentName} . Please confirm if you wish to proceed with the unbinding",
  },
  bombRule: {
    afterThe:
      " After the detonation value in the room reaches the certain amount, the gift bomb will appear in the room",
    oneCoins: " 1 coins received in the room = 1 detonation value",
    itWill:
      "It will automatically explode after meeting the requirements, and the room owner will receive corresponding gold coin rewards",
  },
  descriptionLevel: {
    wealth: "Wealth",
    charm: "Charm",
    wealthValue: "Wealth Value",
    charmValue: "Charm Value",
    needTo: "Need to",
    send: "send",
    receive: "receive",
    forThe: "for the upgrade",
    theRich: "The Rich level is counted by the coins you had recharged",
    theCharm:
      "The Charm level is calculated based on the number of coins you receive",
    LevelLabel: "Level Label",
    level: "Level",
    levelLogo: "Level Logo",
  },
  gameRank: {
    gameRank: "Game Rank",
    rules: "Rules",
    thisWeek: "This Week",
    lastWeek: "Last Week",
    agentGaming: "Agent Gaming Revenue Ranking",
    rankingRewards: "Ranking Rewards",
    rankingIs:
      "Ranking is based on the total betting turnover of users in the agent's room and its sub-rooms.",
    hostRoom: "Host room Revenue Ranking",
    rankingIs2:
      " Ranking is based on the total gaming revenue generated in the host's room",
    notes: "Notes",
    eventDuration: "Event duration: Each calendar week.",
    rewardsAre:
      "Rewards are distributed only if the corresponding revenue requirements are met.",
    allRewards:
      "All rewards will be issued within 1-2 working days after the event ends.",
    halaReserves:
      "Hala reserves the right to the final interpretation of this event",
    rewardsDetail: "Rewards Detail",
    decorationsPreview: "Decorations Preview",
  },
  gameLegacyHall: {
    surpriseLucky: "Surprise Lucky Bag",
    dailyPlayers:
      "Daily players can open a Lucky bag the next day for random coins",
    eventRule: "Event Rule",
    usersSpending:
      " Users’ spending in event games will count towards their ranking score",
    thePlatform:
      "       The platform will rotate event games every 4 hours, with 4 different games featured in each rotation       ",
    theTop: "The top 3 daily players will receive frames and coin rewards",
    theTop2: "The top 10 weekly players will receive frames and coin rewards",
    usersWho:
      " Users who participate in event games each day can open a lucky bag the next day to receive random amount of coins. The more you spend in event games, the more coins you may get",
    behindPrevious: "Behind previous",
    thisWeek: "This Week",
    lastWeek: "Last Week",
    countdown: "Countdown",
    days: "Days",
    winOver: "Win over",
    coinsfrom: "coins from games in a single day",
    earnOver: "Earn over",
    coinsWitdh: "with return rate up to ",
    fromOneDay: "from one day in",
    game: "game",
    fromA: "from a single bet in",
    inthisWeek: "In This Week",
    earnUp: " Earn up to",
    inAsingle: "in a single day",
    eventRules: "Event Rules",
    participateIn:
      "Participate in the game to claim a larger lucky bag tomorrow",
    youDid:
      "You did not receive the coin reward. Participate in the game and you can continue to claim the lucky bag tomorrow",
    participateIn2:
      "Participate in the game and you can continue to claim the lucky bag tomorrow",
    topDaily: "Top Daily Coin Winner",
    topPayout: "Top Payout Rate Winner",
    topCoins: "Top Coins Winner In One Round Weekly",
    topPayout2: "Top Payout Rate Winner In A Single Round Weekly",
    topWeekly: "Top Weekly Coins Winner",
    historicalTop: "Historical Top Coins Winner In One Day",
    historicalTop2: "Historical Top Payout Rate Winner In A Single Day",
    historicalTop3: "Historical Top Coins Winner In One Round",
    historicalTop4: "Historical Top Payout Rate Winner In A Single Round",
    historicalTop5: "Historical Top Coins Winner In A Week",
    gameReward: "Game Reward Rules",
    usersSpending2:
      "Users’ spending in event games will count towards their ranking score",
    theTop3: "The top 3 daily players will receive frames and coin rewards",
    theTop4: "The top 10 weekly players will receive frames and coin rewards",
    usersWho2:
      "Users who participate in event games each day can open a lucky bag the next day to receive random amount of coins. The more you spend in event games, the more coins you may get",
    coins: "Coins",
    flameRider: "Flame Rider",
    sportCar: "Sport Car",
    captainMeow: "Captain Meow",
    profileFrame: "Profile Frame",
  },
  gold: {
    coinsDetail: "Coins Detail",
    coinBalance: "Coin Balance",
    all: "ALL",
    sendGifts: "Send Gifts",
    purchaseItems: "Purchase Items",
    games: "Games",
    exchange: "Exchange",
    recharge: "Recharge",
    activeReword: "Activity Rewards",
  },
  integral: {
    all: "All",
    cashOut: "Cash out",
    transfer: "Transfer",
    withdrawDetail: "Withdraw Detail",
    orderId: "Order ID",
    paymentMenthod: "Payment Menthod",
    withdrawalTime: "Withdrawal Time",
    pointsAmount: "Points Amount",
    depositAmount: "Deposit Amount",
    coinsAmount: "Coins Amount",
    transferTo: "Transfer to",
    normal: "Normal",
    pending: "Pending",
    success: "Success",
    failed: "Failed",
    points: "Points",
    pointsBalance: "Points Balance",
    frozenPoints: "Frozen Points",
    details: "Details",
    exchange: "Exchange",
    currencyType: "Currency Type",
    paymentMethod: "Payment method",
    pointsAmount2: "Points amount for cashing out",
    enterA: "Enter a multiple of 100,000 (minimum 200,000)",
    enterA2: "Enter a multiple of 100000",
    accountInformation: "Account information",
    withdraw: "Withdraw",
    amount: "Amount",
    exchangeRate: "Exchange rate",
    exchangePoints: "Exchange Points",
    enterUserId: "Enter User ID",
    check: "Check",
    fee: "Fee",
    theAgency: "The Agency will receive",
    transferFee: "Transfer fee： 2%. Minimum transfer ≥ 100,000 points.",
    clickTransfer:
      "Click transfer button to transfer the corresponding points to your agents",
    afterThe2:
      "After the transfer finished, it can't be cancelled or withdrawn",
    transferPoints: "Transfer Points",
    recommendedMethod: "Recommended Method",
    lowerFees: " Lower fees and reviewed within 24 hours",
    paymentPassword: "Payment password not set",
    cashOut2:
      " Cash out and Exchanges require payment password verification. Please set up your payment password first.",
    cancel: "Cancel",
    goTo: "Go to Settings",
    youHave:
      "You have reached 5 failed attempts. One more failed attempt will result in your account being frozen. If you have forgotten your password, please reset it",
    inputIncorrect:
      " Input incorrect password many times. Your account has been frozen, please try again after ",
    verify: "verify",
    gotIt: "Got it",
    pointsInfo: "Points Info",
    whenA:
      "When a user sends you gifts using Coins recharged via Google, the points you receive will be frozen for 7 days before becoming available. If the user requests a refund, those points will be deducted. Please follow platform rules and avoid any violations.",
    frozenPointsAre: "Frozen Points are included in total Points Balance",
    theUser2: "The user has been blacklisted",
    successfulWithdrawal: "Successful Withdrawal",
    withdrawalAmount: "Withdrawal Amount",
    theFunds: "The funds will arrive within 24 hours",
    pleaseEnter2: "Please enter the password",
    passwordIncorrect: "Password incorrect",
    theAmount4: "The amount must be a multiple of 100000",
    pleaseEnter3: "Please enter the User ID",
    pleaseEnter4: "Please enter the correct User ID",
    pleaseEnter5: "Please enter the amount",
    minimumTransfer: "Minimum transfer ≥ 100,000 points",
    pleaseSelect3: "Please select the method",
    minimum: "minimum",
    theAmount5: "The amount must be less than ",
    illegalInput: "Illegal input",
    pleaseEnter6: "Please enter the Account information",
  },
  invite: {
    inviteGame: "Invite Game User",
    currentRebate: "Current Rebate",
    need: "need",
    toProgress: "to progress to the next level",
    gameReward: "Game Reward",
    referralData: " Referral Data",
    referralList: " Referral List",
    date: "Date",
    gameBets: "Game Bets",
    inviteRewards: "Invite Rewards",
    viewMore: "View More",
    inviteFriends: "Invite Friends",
    myReward: "My Reward",
    totalRewards: "Total Rewards",
    dailyReward: "Daily Reward",
    inviteRules: "Invite Rules",
    yourRebate:
      " Your Rebate Rate depends on your Total Valid Bets in the last 30 days",
    totalValid2:
      "Total Valid Bets = Your self bets + The self bets of each tier of your invited users",
    rebateFrom:
      "Rebate from Tier-1 invited users = Their self bets × Your rebate rate",
    rebateFrom2:
      "Rebate from Tier-2 invited users = Their self bets × (Your rebate rate - Tier-1 rebate rate)",
    ifThe:
      "If the Tier-2 invited user invites a Tier-3 user, it can increase his Total Valid Bets, but he cannot get a rebate from Tier-3.",
    example: "Example",
    tier1:
      "Tier-1 invited - How to calculate the rebate from those who are directly invited by you?",
    asRebate:
      "A's Rebate from B, C and D = (B's Self Bets + C's Self Bets + D’s Self Bets) × A's Rebate Rate = (20M+ 10M+5M) × 0.5% =",
    bsRebate:
      " B's Rebate from E and F = (E's Self Bets + F's Self Bets) × B's Rebate Rate = (800M+ 200M) × 0.5% =",
    csRebate:
      "C's Rebate from G = G's Self Bets × C's Rebate Rate = 10M × 0.2%",
    tier2:
      "Tier-2 invited - How to calculate the rebate from those who are indirectly invited by you?",
    asRebate2:
      " A's Rebate from E and F = (A's Rebate Rate - B's Rebate Rate) × (E's Self Bets + F's Self Bets) = (0.5%-0.5%) × (800M+200M) =",
    asRebate3:
      "A's Rebate from G = (A's Rebate Rate - C's Rebate Rate) × G's Self Bets = (0.5%-0.2%) × 10M ",
    myInvitation: "My Invitation",
    search: "Search",
    invitationTime: "Invitation time",
    inviteHost: "Invite Host",
    inviteA: "Invite a Host, Each up to",
    todayRewards: "Today Rewards",
    rewardDetail: "Reward Detail",
    creatorRewards: "Creator Rewards Wallet",
    collect: "Collect",
    invitationDate: "Invitation Date",
    hostPolicy: "Host Policy",
    halaReserves2:
      " Hala reserves the right of final interpretation of the above policies.",
  },
  listContribution: {
    contributiont: "Contributiont",
    host: "Host",
    wealth: "Wealth",
    today: "Today",
    yesterday: "Yesterday",
    game: "Game",
    gift: "Gift",
    hostEarnings: "Host Earnings",
  },
  missionRule: {
    hostPolicy: "Host Policy",
    halaReserves3:
      " Hala reserves the right of final interpretation of the above policies",
  },
  purchase: {
    recharge: "Recharge",
    userId: "User ID",
    confirm: "Confirm",
    switchAccount: "Switch account",
    countryRegion: "Country/Region",
    officialAgency: "Official Agency Recharge",
    ttOff: "20% off",
    totalAmount: "Total Amount",
    purchase: "Purchase",
    pleaseComfirm: "please comfirm User ID",
    pleaseInput8: "Please input the User ID",
    onlineService: "Online Service",
    dealOf: "Deal of last 30 days",
    recent30Day2: "Recent 30-Day Coin Sales",
    paymentMethod: "Payment Method",
    whatsapp: "WhatsApp",
    chat: "Chat",
    yourCountry2: "Your country currently has no available coin sellers",
    pleaseContact2: " Please contact customer support.",
    customerSupport: "customer support",
    contact: "Contact",
  },
  roomGiftRule: {
    eventRules: "Event Rules",
    treasureChest:
      " Treasure chest progress is increased by giving  gifts in the room",
    whenThe:
      "When the progress bar of the chest key is filled up, the treasure chest will be opened",
    afterThe3:
      ".After the level 3 and level 4 treasure chests meet the requirements, they will be locked for 1 minute and then automatically opened",
    everyoneIn:
      " Everyone in the room has a chance to get the rewards in the treasure chest",
    onceThe:
      " Once the treasure chest is opened, it may take several minutes for the system to issue the reward to your account. The gold coins will be added to your balance and the costume will be added to your inventory",
    theHigher:
      "The higher the level of the treasure chest, the bigger the rewards in it",
    ifYou2:
      "If you are selected as a VIP with a lower VIP level than your current one, the VIP level will not take effect",
    theProgress:
      "The progress bar of the chest key will be reset at 00:00 (UTC+5:30) everyday",
  },
  share: {
    joinHala:
      " Join Hala to unlock multiple earning opportunities and enjoy tailored benefits and rewards for Agencies.",
    downloadTo: "Download to Become a Partner",
    joinHala2: " Join Hala for fun games and a chance to win amazing prizes.",
    downloadAnd: "Download and Start Winning",
    joinHala3:
      " Join Hala and start your hosting journey. Earn daily bonuses up to $36!",
    inviteYou: "Invite you to join Agency",
    downloadNow: "Download Now to Start Hosting",
    comeWith: "Come with me to join chat room in Hala",
    enthusiastsFrom:
      "enthusiasts from around the globe come together to share...",
    igniteEndless: "Ignite endless amusement",
    download: "Download",
    halaLive: "Hala Live",
    showMe: "Show Me Happy the World",
    saySomething: " Say something...",
    downloadHala: "Download Hala App",
  },
  starHost: {
    starHost: "Star Host",
    level2: "Level {level}  maintained for {days} days",
    currentSalary: " Current Salary",
    points: "Points",
    likes: "Likes",
    stillNeed: "Still need",
    done: "Done",
    numberOf2: "Number of Gifters",
    gifters: "Gifters",
    gcoinGifts: "Gcoin Gifts",
    gifts: "gifts",
    liveDuration: "Live Duration",
    min: "min",
    completeAll: "Complete all of the following tasks to upgrade",
    follower: "Follower",
    numberOf3: "Number of Gifters",
    daysAt: "Days at {level} Level",
    giftCollection: "Gift Collection",
    gift: "Gift",
    date: "Date",
    expectedSalary: "Expected Salary",
    gcoin: "Gcoin",
    status: "Status",
    levelReached: " Level Reached",
    notAchieved: "Not Achieved",
    starHost2: "Star host rules",
    eachStar: "Each Star Host has a 3-day trial period",
    theyWill:
      "They will only become an official Star Host if they meet the A-level standards for all 3 days",
    thoseWho: "Those who fail to meet the daily A-level targets will be fired",
    firedHosts: "Fired hosts can't earn Star Host base salary",
    starHost3: "Star Host base salary is paid weekly, every Monday",
    ifA:
      "If a Star Host fails to complete the daily tasks, they will only receive 50% of the hourly salary",
    selfGifting: "Self-gifting is strictly prohibited for all gift targets",
    starHost4: "Star Host Rewards of Different Levels",
    level: "Level",
    dailyExtra: "Daily Extra  Points Rewards",
    liveBroadcast: "Live broadcast time required",
    starHost5: "Star Host Requirement for different levels",
    requirements: "Requirement(s)",
    yourApplication: "Your application is approved by official",
    stayOn: "Stay on A-level for 7 days",
    over1k: "Over 1k fans",
    totalGifter: "Total gifter number > 300",
    receiveAll: 'Receive all "Lucky" gifts',
    everyLucky: "Every lucky gifts number should be over 100",
    stayOn2: "Stay on S-Level for 10 days",
    over2k: "Over 2k fans",
    totalGifter2: "Total gifter number> 300",
    receiveAll2: 'Receive all "Hot" gifts',
    stayOn3: "Stay on SS-Level for 10 days",
    over5k: "Over 5k fans",
    totalGifter3: "Total gifter number > 1000",
    receiveAll3: 'Receive all "Luxury" gifts',
    starHost6: "Star Host Daily Tasks",
    dailyAssessment: "(Daily Assessment System): Interaction / Gifts",
    gcionGifts: "Gcion Gifts",
    rulesTo: "Rules to degrade Star Host Level",
    failTo:
      "Fail to meet the current level’s standards for 3 consecutive days.",
    failingTo: "Failing to meet the standards <span>3 times within a week",
    ifThe2:
      "If the host who fail to meet the daily requirement is A-level , she/he  will be directly fired instead of degraded. After degraded, the host must meet the original level’s standards for 3 consecutive days to regain the level",
    involvementIn: "Involvement in major violations or negative incidents.",
    causingDamage: "Causing damage to the platform’s interests or brand image",
    applyFor: "Apply for quit by yourself",
    liveStreaming: "Live Streaming Requirements",
    liveStream:
      "Live stream content must align with the host's designated type",
    roomHosts:
      " Room hosts are prohibited from muting their microphone for extended periods during broadcasts",
    liveStreams:
      "Live streams must be conducted using a 9-seat microphone room layout.",
    otherSeats:
      "Other seats in the room are not allowed to be occupied by users or audience members who mute their microphones for task farming purposes.",
    discriminatoryInsulting:
      "Discriminatory, insulting, or offensive remarks are strictly prohibited in the room",
  },
  starRoom: {
    afterCountdown:
      " After countdown every day, Top3 rooms will be listed in the Star Room Rank",
    top20Star:
      " Top20 star rooms will be rewarded as bountiful bonus after this week",
    countdown: "Countdown：",
    top3Daily:
      "Top3 daily top3 rooms will be qualified to join weekly star rooms",
    starRooms:
      "Star rooms will be ranked on the last day of the week. It will be ranked according to the total coins flow of every room",
    top20Weekly: "Top20 weekly star room owners will get rewards as following",
    qualificationTo:
      "Qualification to participate this event: Any violations or illegal behavior is not allow in room, once found, hala will disqualify the room and remove it from the rank",
    theRewards: "The rewards will be sent every Monday.",
    days: "days",
    coins: "Coins",
  },
  inviteActive: {
    inviteHosts: "Invite Hosts",
    pointsMax: "5,000 points max daily",
    firstRecharge: "First-recharge users",
    get20: "Get $20 for Free",
    oneInvite:
      "1.Invite hosts to start live, when the hosts you invited finish.",
    aFinish: "a. Finish face verification on task center",
    bCreate: "b.Create her own room",
    cLive: " c.Live on mic for 3 hours in her room",
    dClaim: "d.Claim the live rewards for the first time",
    youGet:
      "You get points rewards every day from your valid invited hosts numbers. You can claim the rewards next day.",
    validHost: "Valid host",
    pointsReward: "Points Reward",
    youCan: " You can earn up to 5,000 invite points per day",
    myInvited: "My invited hosts",
    validHosts: "Valid Hosts Today",
    pointsRewards: "Points Rewards",
    validHosts2: "Valid Hosts Yesterday:",
    claim: "Claim",
    claimed: "Claimed",
    completedTime: "Completed Time",
    ifYour:
      "If your friends finish first-recharge, you will get plenty of rewards.(Offline recharge will also be included).",
    theMore:
      "The more the first recharge amount reaches, the more coins you will be rewarded, and it's up to $20 daily.",
    inviteesRecharge: "Invitees Recharge coins",
    yourReward: "Your Reward Coins",
    threeOnly:
      "Only users who are invited recharge within 30 days will be counted as valid first-recharge users.",
    seniorAnd:
      " Senior and standard seller will be counted only when they recharge from the app or official directly ( come to your admin for payment methods）for the first time will be counted as valid first-recharge users.",
    myInvited2: "My invited Users",
    rechargeCoins: "Recharge coins",
    coinsRewards: "Coins Rewards",
    firstRecharge2: "First-recharge coins Yesterday:",
    firstRecharge3: "First-recharge Coins",
    firstRecharge4: "First-recharge Time",
  },
  hostPolicy: {
    title: "Host Policy",
    section1Title: "New Host First Week Base Salary",
    requirement: "Requirement",
    newHostsDesc: "New hosts who joined Hala in the first week",
    activeTime: "Active Time on Mic",
    oneHour: "1 Hour",
    twoHour: "2 Hour",
    threeHour: "3 Hour",
    baseSalary: "Base Salary (Points)",
    incomeRequirement: "Income Requirement",
    none: "None",
    remarks: "Remarks",
    remarksDesc:
      "Maximum 3 hours/day.Maximum 7 days. Total maximum reward of 35,000 points",
    note1:
      "From the date of the hosts registration, the 7-day basic salary validity period begins countdown.",
    note2:
      "Hosts using multiple accounts or logging in with multiple IPs or devices will be disqualified from the base salary reward.",
    note3:
      "If the host last 7 days income is over 150,000 points, she will get Ordinary Host Hourly Reward instead of New Host Base Salary Reward.",
    section2Title: "Ordinary Host Equally Reward",
    level: "Level",
    incomeRequirementShort: "Income Requirement",
    hourlyReward: "Hourly Reward",
    maximumDailyHours: "Maximum Daily Hours",
    section2Note1:
      "15 minutes continuously on Mic will be counted as effective time.",
    section2Note2:
      "All rewards are settled in points, and need to be claimed on task system.",
    section2Note3: "Platform rewards won't be counted to points requirement.",
    section2Note4:
      "Points will be deducted once multiple IPs or devices are detected.",
    section2Note5:
      "Past 7 days means past 6 days+today, so your hourly rewards may get more as your reach higher points level timely.",
    section2Note6:
      "L-level non-target rewards will only be valid for the first 7 days after registration. After 7 days, hosts can get 500 free points every day permanently.",
    section3Title: "Host Regulations",
    regulation1: "It is prohibited for hosts to register multiple accounts.",
    regulation2: "It is prohibited to promote third-party platforms.",
    regulation3: "Minors are extremely prohibited.",
    regulation4:
      "A host can only have one verified ID. Only verified IDs can start live streaming and withdraw earnings.",
    regulation5:
      "Any act of impersonating facial authentication to start live streaming or withdraw earnings will be permanently banned.",
    regulation6:
      "Providing ID to others for live streaming will result in the ID being permanently banned by the system.",
    regulation7:
      "In the voice room, hosts must actively greet users entering the room.",
    regulation8:
      "The voice room cover photo must use a real, compliant photo of the host.",
    regulation9:
      "Hala platform strictly prohibits any fraudulent activities. Any violations will result in permanent account suspension.",
    footer:
      "Hala reserves the right of final interpretation of the above policies.",
  },
};
